import {Component, Injector, Input} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {NewCertificationService} from "./services/new-certification.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {CertificationRefreshService} from "./services/certification-refresh.service";
import {ViewObjectiveDialog} from "./modals/view-objective.dialog";

@Component({
    selector: 'app-new-certification-objective-list',
    templateUrl: './new-certification-objective-list.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationObjectiveListComponent extends BasePageComponentDirective<any> {

    domains: any[] = [];

    @Input() providers: any[] = [];
    @Input() attendanceTypes: any = {};
    @Input() certification: any = null;

    showCloseSearch = false;

    constructor(
        injector: Injector,
        private certificationService: NewCertificationService,
        private refreshSvc: CertificationRefreshService
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.query();
        this.refreshSvc.currentMessage.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

    query(): void {
        this.tableLoading = true;
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['domainName'];
        this.certificationService.getAllDomains(this.pageQuery, this.certification.id).then(r => {
            this.domains = r.content;

            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    addNewObjective(certificationDomainId: number) {
        this.router.navigate([`/office/new-certification/detail/${this.certification.id}/domain/${certificationDomainId}/objective/add-new`]).then();
    }

    detailObjective(certificationDomainId: number, certificationObjectiveId: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';

        const domain = this.domains.find(d => d.id === certificationDomainId);

        this.dialog.open(ViewObjectiveDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                certificationDomainId: certificationDomainId,
                certificationObjectiveId: certificationObjectiveId,
                domain: domain,
                certification: this.certification,
                objective: domain.objectives.find((o: { id: number; }) => o.id === certificationObjectiveId)
            }
        })
    }

    editObjective(certificationDomainId: number, certificationObjectiveId: number) {
        this.router.navigate([`/office/new-certification/detail/${this.certification.id}/domain/${certificationDomainId}/objective/${certificationObjectiveId}/edit`]).then();
    }

    deleteObjective(certificationDomainId: number, certificationObjectiveId: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Delete Certification Target Objective" ,
                subMessage: "Are you sure want to delete certification target objective?",
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.certificationService.deleteCertificationDomainObjective(this.certification?.id, certificationDomainId, certificationObjectiveId).then(r => {
                    this.showSnackbarDark('Certification Target Objective', 'Certification target objective has been deleted successfully', '');
                    this.refreshSvc.changeMessage(Math.random());

                })

            }
        })
    }
}
